export default class EventContext {
  public error?: any

  public constructor(
    public effects,
    public event,
  ) {}
}
